// 2026-10-24：主筛选搜索框按提示文字测宽，不参与窗口宽度的比例伸缩。
export function measurePlaceholderWidth(input: HTMLInputElement): number {
  const doc = input.ownerDocument
  const view = doc.defaultView
  if (!view) return 0
  const style = view.getComputedStyle(input)
  const ruler = doc.createElement('span')
  ruler.textContent = input.placeholder
  ruler.style.cssText = 'position:fixed;left:-10000px;top:0;white-space:pre;visibility:hidden;pointer-events:none;'
  // font简写可能为空，逐项复制以保证使用输入框的真实字体和字号。
  ruler.style.fontSize = style.fontSize
  ruler.style.fontFamily = style.fontFamily
  ruler.style.fontWeight = style.fontWeight
  ruler.style.fontStyle = style.fontStyle
  ruler.style.fontStretch = style.fontStretch
  ruler.style.fontVariant = style.fontVariant
  ruler.style.letterSpacing = style.letterSpacing
  doc.body.appendChild(ruler)
  try {
    const px = (value: string) => parseFloat(value) || 0
    return Math.ceil(ruler.getBoundingClientRect().width + px(style.paddingLeft) + px(style.paddingRight)
      + px(style.borderLeftWidth) + px(style.borderRightWidth) + 12)
  } finally {
    ruler.remove()
  }
}

export function observeFilterSearchWidths(root: HTMLElement): () => void {
  const view = root.ownerDocument.defaultView
  if (!view) return () => undefined
  const previous = new Map<HTMLElement, { value: string; priority: string; hadClass: boolean }>()
  const selector = '.admin-list-toolbar .search-text > input.ant-input[placeholder], .admin-list-toolbar .order-filter-search > input.ant-input[placeholder]'
  let stopped = false
  let frame = 0
  const restore = (host: HTMLElement) => {
    const saved = previous.get(host)
    if (!saved) return
    if (saved.value) host.style.setProperty('--filter-search-width', saved.value, saved.priority)
    else host.style.removeProperty('--filter-search-width')
    if (!saved.hadClass) host.classList.remove('placeholder-search-width')
    previous.delete(host)
  }
  const measure = () => {
    frame = 0
    if (stopped) return
    const current = new Set<HTMLElement>()
    root.querySelectorAll<HTMLInputElement>(selector).forEach(input => {
      // 不改弹层中的查询框、日期控件或金额区间输入。
      if (!input.placeholder || !input.getClientRects().length || input.closest('.ant-modal,.ant-drawer,.c-modal-cover')) return
      const host = input.parentElement
      if (!host) return
      current.add(host)
      if (!previous.has(host)) previous.set(host, {
        value: host.style.getPropertyValue('--filter-search-width'),
        priority: host.style.getPropertyPriority('--filter-search-width'),
        hadClass: host.classList.contains('placeholder-search-width')
      })
      host.style.setProperty('--filter-search-width', measurePlaceholderWidth(input) + 'px')
      host.classList.add('placeholder-search-width')
    })
    previous.forEach((_saved, host) => { if (!current.has(host)) restore(host) })
  }
  const schedule = () => { if (!stopped && !frame) frame = view.requestAnimationFrame(measure) }
  const observer = new MutationObserver(schedule)
  observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['placeholder'] })
  root.ownerDocument.fonts?.ready.then(schedule)
  root.ownerDocument.fonts?.addEventListener('loadingdone', schedule)
  schedule()
  return () => {
    stopped = true
    if (frame) view.cancelAnimationFrame(frame)
    observer.disconnect()
    root.ownerDocument.fonts?.removeEventListener('loadingdone', schedule)
    previous.forEach((_saved, host) => restore(host))
  }
}
